<template>
    <i class="fa font_lg secondary_color" :class="icon"></i>
</template>

<script>
export default {
	data() {
		return {
			icon: ""
        }
    },
    beforeMount() {
      let value = this.params.value;
      // if no value is set there is nothing to show
      if (value === undefined || value === null) {
        this.icon = "";
      } else {
        if (this.params.value === true || this.params.value === 1) {
          this.icon = "fa-check"
        } else {
          this.icon = "fa-times"
        }
      }
    }
};
</script>

<style lang="scss">
</style>
